import { Component, OnInit } from '@angular/core';
import { UserEditFormComponent } from './user-edit-form/user-edit-form.component';
import { UserActionsFormComponent } from './user-actions-form/user-actions-form.component';
import { MatDialog, MatDialogRef } from '@angular/material';
import { DataTableComponent } from '../datatable/datatable.component';
import { AppService } from '../../services/app.service';
import { UserService } from '../../services/user.service';
import { Datatable } from '../../models/datatable.model';
import { SharedService } from '../../services/shared'; 

@Component({
  selector: 'app-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.scss']
})
export class UserComponent implements OnInit {
  public data;
  translations: any;
  editFormDialogRef: MatDialogRef<UserEditFormComponent>;
  actionsFormDialogRef: MatDialogRef<UserActionsFormComponent>;
  public length;
  pageIndex: Number = 0;
  pageSize: Number = 10;
  filterText: String = '';
  sortDirection: String = 'asc';
  sortHeaderName: String = 'Name';
  sortColumnNameById: String = 'Id';

  constructor(
    private userService: UserService,
    public appService: AppService,
    private datatableComponent: DataTableComponent,
    public dialog: MatDialog,
    private datatableProp: Datatable,
    private sharedService: SharedService
  ) {
    this.appService.showLoading();
    this.setPageTranslations();
  
    this.appService.checkSession();
    

  }

  ngOnInit() {
    this.getUsers();
  }
  setPageTranslations(){
    this.translations = JSON.parse(sessionStorage.getItem('pageData')); 
  } 
  getUsers(): void {
    this.userService.all(this.pageIndex,this.pageSize,this.sortColumnNameById,this.sortDirection,this.filterText).subscribe(
      res => this.getAllUserSuccess(res),
      error => this.apiFaillure(error)
    );
  }

  getAllUserSuccess(res): void {
    this.data = [];
    if (res.Status && res.Data != undefined) {
      this.data = JSON.parse(res.Data).Table;
      this.datatableProp = this.appService.mapDataTableProp(this.datatableProp,JSON.parse(res.Data).Table1[0]);      
      this.datatableProp.gridControl = JSON.parse(res.Data).Table2;
      this.datatableProp.columnKeyData = JSON.parse(res.Data).Table3;
      this.length = this.data.length == 0 ? 0 : JSON.parse(res.Data).Table[0].MaxRowNumber;
      this.sharedService.Data.next(this.data);
      this.appService.hideLoading();
    } else {
      this.apiFaillure(this.translations[res.Message]);
    } 
  }
  apiFaillure(error): void {
    this.appService.hideLoading();
    this.appService.showDialogue(this.translations.hdError, this.translations[error]);
  }
  editRecord(e): void {
    this.appService.showLoading();
    this.editFormDialogRef = this.dialog.open(UserEditFormComponent, {
      disableClose: true,
      data: {
        Id: e.currentTarget.id
      },
      panelClass: 'my-dialog'
    });
    this.editFormDialogRef.afterClosed()
      .subscribe((response) => {
        this.appService.showLoading();
        this.data = '';
        this.getUsers();
    });
  }
  deleteRecord(e): void {
    if(typeof this.translations.hdConfirm == 'undefined'){
      this.setPageTranslations();
    }
    var userId = e.currentTarget.id;
     this.appService.showDialogue(this.translations.hdConfirm, this.translations.confrimMessage ,true)
    .afterClosed().subscribe(result => {
      if (result) {
        this.appService.showLoading();
        this.deleteConfirm(userId);
      }          
    });
  }
  deleteConfirm(userId){
    this.appService.showLoading();
     this.userService.delete(userId).subscribe(
      res => this.deleteSuccess(res),
      error => this.apiFaillure(error)
    );
  }
  deleteSuccess(res){   
    this.appService.hideLoading();
    if (res.Status == 1){
        this.appService.showDialogue(this.translations.hdSuccess, this.translations[res.Message])
        .afterClosed().subscribe(result => {
            if (result) {            
             this.appService.hideLoading();
             this.data = '';
             this.getUsers();
            }          
        });        
    }
    else if (res.Status == -1) {
        this.apiFaillure(res.Message);
    } 
  }
  addRecord(): void {
    this.appService.showLoading();
    this.editFormDialogRef = this.dialog.open(UserEditFormComponent, {
      disableClose: true,
      data: {
        Id: 0
      },
      panelClass: 'my-dialog'
    });
    this.editFormDialogRef.afterClosed()
      .subscribe((response) => {
        this.appService.showLoading();
        this.data = '';
        this.getUsers();
      });
  }
  changeAccess(e){
    this.appService.showLoading();
    var id = e.target.getAttribute('id');
    var actionType = e.target.getAttribute('class');
    actionType = actionType.replace('mat-icon material-icons ','');
    this.actionsFormDialogRef = this.dialog.open(UserActionsFormComponent, {
      disableClose: true,
      data: {
        Id: id,
        type: actionType
      },
      panelClass: 'my-dialog'
    });
    this.actionsFormDialogRef.afterClosed()
      .subscribe((response) => {
        this.appService.showLoading();
        this.data = '';
        this.getUsers();
      });  
  }  
  getServerData(event){
    this.datatableProp = new Datatable();
    this.pageIndex = event.pageIndex;
    this.pageSize = event.pageSize;
    this.getUsers();
 }
 applyFilter(filterValue: any){
    this.datatableProp = new Datatable();
    this.filterText = filterValue;
    this.getUsers();
 }
 getSortedData(event){
    this.datatableProp = new Datatable();
    this.sortColumnNameById = event.currentTarget.getAttribute('id');
    this.getUsers();
 }
}



// WEBPACK FOOTER //
// D:/Keval/Project/Mindport/HRS/hantraco-app/src/app/main/content/components/user/user.component.ts